// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2ZBG8","selected":"Chip_selected__2zFrt"};